import React from 'react';
import Box from '@mui/material/Box';

export function SpeechBubble({
  backgroundColor = '#eff1f5',
  borderColor = '#8aa1c2',
  children,
}) {
  return (
    <Box
      sx={{
        position: 'relative',
        border: `3px solid ${borderColor}`,
        borderRadius: '8px',
        backgroundColor: `${backgroundColor}`,
        padding: '30px 15px 7.5px',
        textAlign: 'center',
        lineHeight: '1.415rem',
        '& > h3': {
          fontSize: '1.125rem',
          fontFamily: 'Whitney Bold',
          fontWeight: 700,
          marginBottom: '0.9375rem',
          lineHeight: '1.3125rem',
        },
        '&::before': {
          content: '""',
          display: 'block',
          width: '36px',
          height: '30px',
          position: 'absolute',
          bottom: '-34px',
          left: '27px',
          borderRight: '33px solid transparent',
          borderTop: `33px solid ${borderColor}`,
        },
        '&::after': {
          content: '""',
          display: 'block',
          width: '30px',
          height: '30px',
          position: 'absolute',
          bottom: '-30px',
          left: '30px',
          borderRight: '30px solid transparent',
          borderTop: `30px solid ${backgroundColor}`,
        },
      }}
    >
      {children}
    </Box>
  );
}
